<template>
  <nav>
    <!--[if lte IE 8]>
      <p class="chromeframe">
        You are using an <strong>outdated</strong> browser. Please
        <a href="http://browsehappy.com/">upgrade your browser</a>.
      </p>
    <![endif]-->
    <ul class="nav navbar bg-white justify-content-between align-items-start">
      <li class="nav-item">
        <a href="https://hungerhub.com/" id="logo">
          <!--<router-link to="hungerhub.com" id="logo"> -->
          <img
            src="../assets/img/hh-logo-dark.png"
            alt="Uncatering"
            text-align="center"
            data-retina="true"
            class="logo d-sm-block mx-auto"
          />
          <!--</router-link> -->
        </a>
      </li>

      <li class="w-info" v-if="!isPaymentPage()">
        <div class="d-flex d-md-none flex-wrap">
          <div class="col-6 d-flex flex-column p-2">
            <small class="info-label">Invited by</small>
            <small class="info-subtext">{{ invitedBy }}</small>
          </div>
          <div class="col-6 d-flex flex-column p-2">
            <small class="info-label">Meal</small>
            <small class="info-subtext">{{ meal }}</small>
          </div>
          <div class="col-6 d-flex flex-column p-2">
            <small class="info-label">Meal Date</small>
            <small class="info-subtext">{{ mealDate }}</small>
          </div>
          <div class="col-6 d-flex flex-column p-2">
            <small class="info-label">Delivery time:</small>
            <small class="info-subtext">{{ deliveryTime }}</small>
          </div>
          <div class="col-6 d-flex flex-column p-2">
            <small class="info-label">Deadline to order</small>
            <small class="info-subtext">{{ deadline }}</small>
          </div>
          <div v-if="subsidy > 0" class="col-6 d-flex flex-column p-2">
            <small class="info-label">Subsidy</small>
            <small class="info-subtext">${{ subsidy }}</small>
          </div>
        </div>

        <div class="row d-none d-md-flex">
          <div class="col d-flex flex-column border-right">
            <small class="info-label">Invited by</small>
            <small class="info-subtext">{{ invitedBy }}</small>
          </div>
          <div class="col d-flex flex-column border-right">
            <small class="info-label">Meal</small>
            <small class="info-subtext">{{ meal }} </small>
          </div>
          <div class="col d-flex flex-column border-right">
            <small class="info-label">Meal Date</small>
            <small class="info-subtext">{{ mealDate }}</small>
          </div>
          <div class="col d-flex flex-column border-right">
            <small class="info-label">Delivery time:</small>
            <small class="info-subtext">{{ deliveryTime }}</small>
          </div>
          <div class="col d-flex flex-column border-right">
            <small class="info-label">Deadline to order</small>
            <small class="info-subtext">{{ deadline }}</small>
          </div>
          <div v-if="subsidy > 0" class="col d-flex flex-column">
            <small class="info-label">Subsidy</small>
            <small class="info-subtext">${{ subsidy }}</small>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { logOut, clearPKToken } from "../utils/api";
import { mapState, mapGetters } from "vuex";
import { errorHandler } from "@/utils/errorHandler";
import moment from "moment";
import { getRestaurantsBySlug } from "@/utils/api";
import {
  status,
  extractETA,
  localWithUTCoffset,
  checkAndGetTimezone,
  onlyDate,
  formatDateWithTimezone,
  to12hourformat,
  onlyTime
} from "@/utils/common";

export default {
  name: "GuestHeader",
  data() {
    return {
      invitedBy: "",
      meal: "",
      mealDate: "",
      deliveryTime: "",
      deadline: "",
      subsidy: ""
    };
  },
  computed: {
    ...mapState(["employee"])
  },
  mounted() {
    const slug = this.$route.params.slug;

    if (slug) {
      let loader = this.$loading.show();
      getRestaurantsBySlug({ slug }).then(response => {
        loader.hide();
        if (response?.data) {
          const cutoff = response?.data?.meal_details?.cutoff;
          const isPastDeadline = moment(cutoff).isBefore(moment());

          if (isPastDeadline || !response?.data?.meal_details?.meal_published) {
            this.$router.replace({
              path: "/guest/link-expired",
              query: {
                meal: response?.data?.meal_details?.meal_name,
                mealDate: moment(
                  response?.data?.meal_date,
                  "YYYY-MM-DD"
                ).format("ddd, MMMM D, yyyy"),
                deliveryTime: `${moment(
                  onlyTime(response?.data?.delivery_time),
                  "HH:mm a"
                ).format("h:mm A")}`,
                deadline: formatDateWithTimezone(
                  response?.data?.meal_details?.cutoff,
                  "ddd, MMMM D, yyyy h:mm A",
                  response?.data?.tzinfo
                )
              }
            });
            return;
          }

          const formattedDate = moment(
            response?.data?.meal_date,
            "YYYY-MM-DD"
          ).format("ddd, MMM DD, YYYY");

          this.invitedBy = response?.data?.invited_by;
          this.mealDate = formattedDate;
          this.meal = response?.data?.meal_details?.meal_name;
          this.subsidy = parseFloat(response?.data?.subsidy_remaining).toFixed(
            2
          );

          this.deliveryTime = to12hourformat(
            onlyTime(response?.data?.delivery_time),
            response?.data?.tzinfo
          );

          this.deadline =
            formatDateWithTimezone(
              response?.data?.meal_details?.cutoff,
              "ddd, MMM DD, YYYY",
              response?.data?.tzinfo
            ) +
            " " +
            localWithUTCoffset(
              response?.data?.meal_details?.cutoff,
              response?.data?.tzinfo,
              "h:mm A"
            ) +
            checkAndGetTimezone(response?.data?.tzinfo, true);
        }
      });
    }
  },
  methods: {
    isPaymentPage() {
      return this.$route.path.startsWith("/guest/payments");
    }
  }
};
</script>

<style scoped>
#logo img {
  margin-right: 50px;
}

ul li a {
  color: black;
  font-size: 14px;
  font-weight: 500;
  margin: 2px 0px;
}
.w-info {
  width: 923px;
}

ul li a:hover,
ul li a:focus {
  color: #ec008c;
  text-decoration: none;
  transition: all 0.2s ease;
  outline: none;
}

.info-label {
  color: #2d3958;
  font-size: 14px;
  font-weight: 400;
  font-family: Inter, sans-serif;
}

.info-subtext {
  color: #2d3958;
  font-size: 15px;
  font-weight: 500;
  font-family: Inter, sans-serif;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}
.border-right {
  border-right: 1px;
  border-color: #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/components/GuestHeader.vue